import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { Divider } from '@mui/material';

import { Button, CustomIconButton } from '../../common/button';

const ConfirmDialog = ({
                           isLoading,
                           title,
                           subtitle,
                           maxWidth,
                           cancelText,
                           secondaryAction,
                           secondaryText,
                           primaryAction,
                           primaryText,
                           buttonText,
                           displayIcon,
                           iconTitle,
                           icon
                       }) => {
    const [open, setOpen] = useState(false);

    const onClose = () => setOpen(false);

    return (
        <>
            {
                displayIcon
                    ? <CustomIconButton
                        title={ iconTitle }
                        isLoading={ isLoading }
                        onClick={ () => setOpen(true) }
                        icon={ icon }/>
                    : <Button isLoading={ isLoading } onClick={ () => setOpen(true) }>{ buttonText }</Button>
            }
            <Dialog
                open={ open }
                onClose={ onClose }
                fullWidth
                maxWidth={ maxWidth || 'xs' }
                PaperProps={ {
                    sx: { borderRadius: 2 }
                } }
            >
                <DialogTitle sx={ { pb: subtitle ? 2 : 2, fontWeight: 600 } }>
                    { title }
                </DialogTitle>

                { subtitle && (
                    <>
                        <Divider/>
                        <DialogContent sx={ { py: 3 } }>
                            <DialogContentText sx={ { color: 'text.secondary' } }>
                                { subtitle }
                            </DialogContentText>
                        </DialogContent>
                    </>
                ) }

                <Divider/>

                <DialogActions sx={ { p: 2, gap: 1 } }>
                    {
                        cancelText &&
                        <Button
                            variant="outlined"
                            isLoading={ isLoading }
                            onClick={ onClose }
                        >
                            { cancelText }
                        </Button>
                    }
                    {
                        secondaryText &&
                        <Button
                            variant="outlined"
                            isLoading={ isLoading }
                            onClick={ () => {
                                secondaryAction();
                                onClose();
                            } }
                        >
                            { secondaryText }
                        </Button>
                    }
                    <Button
                        isLoading={ isLoading }
                        onClick={ () => {
                            primaryAction();
                            onClose();
                        } }
                    >
                        { primaryText }
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ConfirmDialog;